// extracted by mini-css-extract-plugin
export default {"StepsContainer":"h5TJdJ5v","active":"YfruZcB6","InactiveStepsContentClass":"W3mT7Yi5"};